<template>
  <div id="main">
    <!-- 主要區塊 -->
    <div class="mainContainer">
      <Thumbnails id="thumbnails" />
      <section class="newsAndBtn wrapBlock">
        <!-- 物管專區 -->
        <Panel id="panel" />
        <!-- 左下公告通知 -->
        <News id="news" />
      </section>
      <section class="advertise">
        <advertise id="ad" />
      </section>
    </div>
    <reader
      ref="reader"
      :manual-input="false"
    />
    <AdModal />
  </div>
</template>

<script>
import Thumbnails from './components/Thumbnails'
import Panel from './components/Panel'
import News from './components/News'
import advertise from './components/advertise'
import ReadNFCBarcode from '@/components/ReadNFCBarcode'
import AdModal from '@/components/AdModal.vue'
import { apiAjax } from '@/api/ajax.js'

export default {
  components: {
    Thumbnails,
    Panel,
    News,
    advertise,
    reader: ReadNFCBarcode,
    AdModal
  },
  beforeRouteLeave (to, from, next) {
    // this.$refs.banner.setBannerActiveIndex()
    next()
  },
  mounted () {
    this.$sendGAEvent('MGMT', {
      screen_name: 'Home'
    })
    const notFirstLoginAccount = JSON.parse(localStorage.getItem('notFirstLoginAccount'))
    const userInfo = JSON.parse(localStorage.getItem('loginUserInfo'))
    const createdHours = (new Date() - new Date(userInfo?.AuthorizationCreateAt)) / (1000 * 3600)
    if (notFirstLoginAccount) {
      const index = notFirstLoginAccount.findIndex(item => item === userInfo.Account)
      if (createdHours < 24 && !userInfo.HasCarrier) {
        if (index === -1) {
          this.nfcOpen()
        }
      } else {
        if (index !== -1) {
          notFirstLoginAccount.splice(index, 1)
          localStorage.setItem('notFirstLoginAccount', JSON.stringify(notFirstLoginAccount))
        }
      }
    } else {
      if (createdHours < 24 && !userInfo.HasCarrier) {
        this.nfcOpen()
      }
    }
    this.checkMessageFeedbackToast()
    this.checkReservationToast()
    this.checkPendingNewsToast()
  },
  methods: {
    nfcOpen () {
      const vobj = this
      const notFirstLoginAccount = JSON.parse(localStorage.getItem('notFirstLoginAccount'))
      const Account = JSON.parse(localStorage.getItem('loginUserInfo')).Account
      if (notFirstLoginAccount) {
        notFirstLoginAccount.push(Account)
        localStorage.setItem('notFirstLoginAccount', JSON.stringify(notFirstLoginAccount))
      } else {
        localStorage.setItem('notFirstLoginAccount', JSON.stringify([Account]))
      }
      const account = JSON.parse(localStorage.getItem('loginUserInfo')).Account.replace('auth_', '')
      this.$refs.reader.getCode((code) => {
                                  sandAPI(code)
                                  function sandAPI (code) {
                                    const codeList = []
                                    let nowInd = 0
                                    if (typeof (code) === 'string') { codeList.push(code) } else { code.map(val => codeList.push(val)) }
                                    if (codeList[nowInd].length < 5) {
                                      vobj.$alert('載具格式錯誤，請再次感應卡片', '警告', {
                                        confirmButtonText: '確認',
                                        type: 'warning',
                                        showClose: false,
                                        roundButton: true,
                                        closeOnClickModal: false,
                                        callback: action => {
                                          vobj.$refs.reader.sandData = false
                                          vobj.$refs.reader.iskeyupStarted = false
                                          vobj.$refs.reader.canSandCode = true
                                          vobj.$refs.reader.code = ''
                                        }
                                      })
                                      return false
                                    }
                                    API()
                                    function API () {
                                      console.log(`ind:${nowInd}`)

                                      apiManagement.GetPostAuthorizationCarrierValidation({
                                        Code: codeList[nowInd]
                                      }).then(() => {
                                        vobj.$confirm(`請再次確認是否要將此載具加入帳號 ${account} ?`, '警告', {
                                          confirmButtonText: '確認',
                                          cancelButtonText: '取消',
                                          type: 'warning'
                                        }).then(() => {
                                          apiManagement.PostAuthorizationCarrier({
                                            Code: codeList[nowInd]
                                          }).then(res => {
                                            vobj.$message({ message: '卡片已綁定成功', type: 'success' })
                                            nowInd++
                                            if (nowInd <= codeList.length - 1) {
                                              API()
                                            } else {
                                              vobj.$refs.reader.close()
                                            }
                                          }).catch(err => {
                                            vobj.$notify.error({ title: '發生未知錯誤!!', message: this.$t('General.PleaseContactUs') })
                                            if (nowInd <= codeList.length - 1) {
                                              API()
                                            } else {
                                              vobj.$refs.reader.close()
                                            }
                                          })
                                        }).catch(() => {
                                          vobj.$refs.reader.close()
                                        })
                                      }).catch(err => {
                                        console.log(err.response)
                                        if (err.response.data.ErrorMessage.Code === 400002) {
                                          vobj.$alert(err.response.data.ErrorMessage.Description, '警告', {
                                            confirmButtonText: '確認',
                                            type: 'warning',
                                            showClose: false,
                                            roundButton: true,
                                            closeOnClickModal: false
                                          })
                                        }
                                        vobj.$refs.reader.close()
                                      })
                                    }
                                  }
                                },
                                'NFC'
      )
    },
    async checkMessageFeedbackToast () {
      try {
        const { data } = await apiAjax.checkMessageFeedback()
        if (data.status === 'true' && parseInt(data.total) > 0) {
          this.$bottomRightToast({
            title: this.$t('BottomRightToast.HasFeedback.Title'),
            content: this.$t('BottomRightToast.HasFeedback.Content'),
            routeName: 'message',
            iconClass: 'icon-feedback'
          })
        }
      } catch (error) {
        console.error('Error checking feedback:', error)
      }
    },
    async checkReservationToast () {
      try {
        const { data } = await apiAjax.checkReservation()
        if (data.status === 'true' && parseInt(data.total) > 0) {
          this.$bottomRightToast({
            title: this.$t('BottomRightToast.HasReservationOfFacility.Title'),
            content: this.$t('BottomRightToast.HasReservationOfFacility.Content'),
            href: '../community/reservationList_v3.aspx',
            iconClass: 'icon-reservation'
          })
        }
      } catch (error) {
        console.error('Error checking reservation:', error)
      }
    },
    async checkPendingNewsToast () {
      const Authorization = this.$getCookie('comLoginToken').replace(
        'token=',
        ''
      )
      axios(`${process.env.VUE_APP_MAPI_URL}/Announcement/PendingAdjustmentCount`, {
        method: 'GET',
        headers: {
          'content-type': 'application/json',
          'cache-control': 'no-cache',
          Authorization
        }
      }).then(async (res) => {
        if (res.data.Data.Count > 0) {
          this.$bottomRightToast({
            title: this.$t('News.ToastTitle'),
            content: this.$t('News.ToastContent'),
            routeName: 'news',
            routeQuery: { preFilter: 'true' },
            iconClass: 'icon-ann'
          })
        }
      })
    }
  }
}
</script>

<style lang="sass" scoped>
$main_width: 1060px
$margin_width: 30px

#main
  position: relative
  box-sizing: border-box
  .mainContainer
    width: 948px
    margin: 0 auto
  .wrapBlock
    box-sizing: border-box
    margin-left: auto
    margin-right: auto
    display: flex
    flex-direction: column
    width: 948px
    border-radius: 8px
    background-color: $bgDark4
    box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.1)
    padding: 20px
    margin-top: 50px
  .newsAndBtn
    padding-bottom: 0px
    #news
    #banner
      width: 50%
      display: inline-block
  .advertise
    #ad
</style>
